export const CATEGORY_DETAILS_LOADED = "CATEGORY_DETAILS_LOADED";
export const CATEGORY_FAQS_LOADED = "CATEGORY_FAQS_LOADED";
export const CATEGORY_LOADED = "CATEGORY_LOADED";
export const CURATED_CATEGORY_TREATMENTS_LOADED =
  "CURATED_CATEGORY_TREATMENTS_LOADED";
export const SET_CATEGORY_ERROR = "SET_CATEGORY_ERROR";
export const CLEAR_CATEGORY_DETAILS = "CLEAR_CATEGORY_DETAILS";
export const CLEAR_CATEGORY_ERROR = "CLEAR_CATEGORY_ERROR";
export const CLEAR_CURATED_CATEGORY_TREATMENTS =
  "CLEAR_CURATED_CATEGORY_TREATMENTS";
export const SIBLING_CATEGORIES_LOADED = "SIBLING_CATEGORIES_LOADED";
export const EARLY_ACCESS_TO_EXCLUSIVES = "EarlyAccessToExclusives";
export const EARLY_ACCESS_TO_NEW_IN = "EarlyAccessToNewIn";
export const LOYALTY_ENABLED_COUNTRIES = ["GB", "US", "DE", "AT"];
export const LOYALTY_NEW_IN_EXPERIMENT_KEY =
  "loyalty-new-in-today-lock-product";
export const MEN_NEW_IN_CATEGORY_ID = 27110;
export const WOMEN_NEW_IN_CATEGORY_ID = 27108;
export const EXCLUDED_SIBLING_CATEGORIES_PARENTS = [
  1000, // Women
  1001, // Men
  1340, // A To Z Of Brands Women
  1361, // A To Z Brands Men
  5526, // Sale / A To Z Brands Women
  8420, // Sale / A To Z Brands Men
  2373 // Face and Body / A To Z Brands Women
];
export const RELATED_CATEGORIES_LOADED = "RELATED_CATEGORIES_LOADED";
export const CATEGORY_LINKS_CAP_REDUCED = 15;
export const CATEGORY_LINKS_REDUCED_CAP_CIDS = [
  4172, // Womens shoes
  4209, // Men's Shoes
  8409, // Men's Sale
  7046 // Women's Sale
];
export const CATEGORY_LINKS_RELATED_CAT_CAP = 5;
export const CATEGORY_LINKS_CAP_DEFAULT = 20;
